"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    曾母暗沙: {
        center: [7.67, 113.24],
        bd: [[6, 115.7], [6, 109.09], [8.86, 109.09], [8.86, 117.3], [7.07, 117.3], [7.12, 117.08], [6.61, 116.14]]
    },
    头顿: {
        center: [10.32, 108.87],
        bd: [[8.86, 110.38], [8.86, 105.46], [9.26, 105.84], [9.26, 106.39], [10.15, 106.77], [11.48, 108.92], [10.1, 111.7]]
    },
    华列拉: {
        center: [12.876, 110.3],
        bd: [[10.1, 111.7], [11.48, 108.97], [11.94, 109.22], [13, 109.32], [14.61, 108.97], [14.64, 111.7]]
    },
    南沙: {
        center: [11.86, 115.51],
        bd: [[8.86, 117.3], [8.86, 110.38], [10.1, 111.7], [13.98, 111.7], [14.01, 120.46], [13.78, 120.54], [13.48, 120.18], [12.49, 120.74], [12.34, 119.85], [11.21, 119.2], [10.85, 119.15]]
    },
    中沙: {
        center: [16.17, 117.42],
        bd: [[14.01, 120.46], [13.99, 113.87], [17.92, 113.9], [17.97, 120.33], [17.94, 120.33], [17.66, 120.28], [16.96, 120.28], [16.55, 120.16], [16.3, 120.41], [16.15, 120.18], [16.28, 119.9], [16.2, 119.75], [14.89, 120.01], [14.31, 120.61]]
    },
    西沙: {
        center: [17.84, 111.92],
        bd: [[13.99, 113.87], [13.98, 111.7], [14.64, 111.7], [14.63, 110.18], [18.58, 110.1], [18.75, 110.43], [19.38, 110.58], [19.58, 110.96], [20.06, 110.86], [20.62, 113.92]]
    },
    海南岛西南部: {
        center: [16.93, 108.84],
        bd: [[14.63, 110.18], [14.61, 108.97], [15.27, 108.84], [17.29, 106.85], [18.3, 108.84], [18.12, 109.4], [18.5, 110.1]]
    },
    北部湾: {
        center: [19.86, 107.65],
        bd: [[18.3, 108.84], [17.29, 106.85], [17.76, 106.42], [17.94, 106.44], [18.22, 106.19], [18.62, 105.84], [19.03, 105.63], [19.56, 105.81], [19.83, 106.09], [20.14, 106.34], [20.16, 106.57], [20.14, 106.67], [20.79, 107.15], [21.15, 107.35], [21.68, 108.51], [21.37, 109.19], [21.43, 109.61], [20.22, 109.92], [20, 109.84], [19.41, 108.72], [18.47, 108.51]]
    },
    东沙: {
        center: [19.76, 116.7],
        bd: [[17.97, 119.55], [17.92, 113.9], [20.62, 113.92], [21.32, 119.53]]
    },
    巴士海峡: {
        center: [19.84, 121.54],
        bd: [[17.99, 123.69], [17.99, 122.23], [18.27, 122.3], [18.55, 122.1], [18.37, 121.87], [18.65, 120.81], [18.55, 120.54], [17.97, 120.33], [17.97, 119.55], [21.32, 119.53], [21.35, 123.67]]
    },
    台湾海峡: {
        center: [23.36, 118.87],
        bd: [[21.33, 120.79], [21.32, 119.53], [23.52, 117.25], [24, 117.83], [24.32, 117.88], [24.35, 118.24], [25.41, 119.55], [25.38, 121.37], [23.47, 120.01], [22.58, 120.13], [22.36, 120.54], [22.13, 120.66], [21.95, 120.59], [21.9, 120.81]]
    },
    汕头附近海面: {
        center: [22.15, 117.73],
        bd: [[21.32, 119.53], [21.11, 117.78], [22.91, 116.29], [23.52, 117.25]]
    },
    汕尾附近海面: {
        center: [21.82, 116.18],
        bd: [[21.11, 117.78], [20.86, 115.78], [22.53, 114.8], [22.74, 115.21], [22.91, 116.29]]
    },
    珠江口外海面: {
        center: [21.41, 114.38],
        bd: [[20.86, 115.78], [20.62, 113.92], [21.9, 113.16], [22, 114.2], [22.19, 115]]
    },
    珠江口内河面: {
        center: [22.26, 113.75],
        bd: [[22.19, 115], [22, 114.2], [21.9, 113.16], [22.08, 113.36], [22.53, 113.65], [22.58, 113.8], [22.21, 114.05], [22.53, 114.8]]
    },
    川山群岛附近海面: {
        center: [21.45, 112.76],
        bd: [[20.62, 113.92], [20.38, 112.58], [21.68, 111.77], [21.75, 112.15], [21.68, 112.55], [21.9, 113.16]]
    },
    湛江附近海面: {
        center: [20.79, 111.39],
        bd: [[20.38, 112.58], [20.06, 110.86], [20.31, 110.51], [21.22, 110.61], [21.45, 111.34], [21.68, 111.77]]
    },
    琼州海峡: {
        center: [20.18, 110.23],
        bd: [[20.06, 110.86], [20, 109.84], [20.22, 109.92], [20.31, 110.51]]
    }
};


//////////////////
// WEBPACK FOOTER
// ./js/boundary.js
// module id = 31
// module chunks = 0